import { render, staticRenderFns } from "./organizationDigiSign.vue?vue&type=template&id=a5944656&"
import script from "./organizationDigiSign.vue?vue&type=script&lang=js&"
export * from "./organizationDigiSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports